/* eslint-disable max-len */
const languageEs = {
    Captions: {
        on: 'subtítulos en',
        off: 'subtítulos desactivados',
    },
    alphabets: {
        Alphabets: 'Abecedario',
        Help: 'Ayuda',
        Reset: 'Reiniciar',
        Reveal: 'Descubrir',
        title: 'Relacionando Jóvenes con Padres',
        help_title: 'Ayuda',
        helpText1:
      'Elija una letra y haga clic para descubrir una imagen de algo que se puede describir con una palabra que empieza por esa letra.',
        helpText2:
      'Pida a los alumnos que adivinen la palabra asociada con la letra y la imagen.',
        helpText3:
      'Si te equivocas, la imagen que hayas elegido desaparecerá y podrás seguir probando hasta que aciertes.',
        helpText4:
      'Haga clic en el botón atrás para volver a la página principal del abecedario.',
        header_main: 'Relacionando Jóvenes con Padres',
        subheader_main:
      'Para jugar, elija una imagen y vea si puede relacionar la cría con el padre.',
        reset_button: 'Reiniciar',
        option_header_main: 'Haga clic en la cría correcta para este adulto.',
        invalid_selection:
      'Buen intento, pero esa no es la cría de este padre. Observe más de cerca.',
        valid_selection:
      '¡Correcto! Ha relacionado al tigre padre con su cría. Ambos tienen pelaje con rayas.',
        reset_confirm: '¿Está seguro?',
        modal_reset_confirm: 'Sí',
        modal_reset_no: 'No',
        caption: '[música alegre]',
    },
    MatchingYoungWithParents: {
        hiss: '[siseo de caimán]',
        ping: '[sonido de campana]',
        quack: '[parpeo de pato]',
        yelp: '[gruñido de león marino]',
        roar: '[rugido de tigre]',
        title: 'Unir a las crías y plántulas con sus padres',
        help_title: 'Ayuda',
        helpText1: 'Encuentra la cría o plántula correcta para cada adulto',
        helpText2:
      'Haz clic en la imagen de la que creas que es la cría o plántula.',
        helpText3:
      'Si te equivocas, la imagen que hayas elegido desaparecerá y podrás seguir probando hasta que aciertes.',
        helpText4:
      'Una vez que elijas la cría correcta, haz clic en «Atrás» para volverlo a intentar con otro animal u otra planta.',
        header_main: 'Unir a las crías y plántulas con sus padres',
        subheader_main:
      'Para este juego, elige una imagen e intenta unir a la cría o plántula con el adulto correspondiente.',
        reset_button: 'Reiniciar',
        option_header_main:
      'Haz clic en la cría o la plántula correcta para este adulto',
        invalid_selection:
      'Buen intento, pero esta no es la cría o la plántula de este adulto. Obsérvalos con más atención.',
        valid_selection:
      '¡Correcto! Has unido al tigre adulto con su cría. Ambos tienen pelaje a rayas.',
        reset_confirm: '¿Estás seguro/a?',
        modal_reset_confirm: 'Sí',
        modal_reset_no: 'No',
        Tiger: 'Tigre',
        striped_fur: 'la piel a rayas',
        Duck: 'Pato',
        flat_bills: 'el pico plano y las patas palmeadas para nadar',
        Alligator: 'Caimán',
        armor_plated_skin:
      'el cuerpo y la cabeza iguales, y la piel recubierta de escamas',
        Sea_lion: 'León marino',
        flipper_shape: 'las aletas iguales y las orejas pequeñas',
        needle_shaped_leaves: 'las hojas con forma de aguja',
        Bean_plant: 'Planta de frijol',
        long_stems: 'los tallos largos y las hojas con forma de corazón',
        Tiger_cub: 'Cachorro de tigre',
        Leopard_cub: 'Cachorro de leopardo',
        Lion_cub: 'Cachorro de león',
        Kitten: 'Gatito',
        Duckling: 'Patito',
        Gosling: 'Gansito',
        Flamingo: 'Flamenco',
        Penguin: 'Pingüino',
        Chameleon: 'Camaleón',
        Trutle: 'Tortuga',
        Iguana: 'Iguana',
        Arctic_seal: 'Foca ártica',
        Grey_seal: 'Foca gris',
        Manatee: 'Manatí',
        Pine_tree: 'Plántula de pino',
        Coconut_tree: 'Plántula de cocotero',
        Oak_tree: 'Plántula de roble',
        Ash_tree: 'Plántula de fresno',
        Corn_offspring: 'Plántula de maíz',
        Tamato_plant: 'Plántula de tomate',
        Squash_plant: 'Plántula de calabaza',
        correct_match:
      '¡Correcto! Has unido al adulto de *PARENT_NAME* con su plántula. Ambos tienen *TRAITS*.',
        wrongOffspring:
      'Buen intento, pero esta no es la cría de este adulto. Obsérvalos con más atención.',
        notItEither:
      'No, esta tampoco es. Busca un rasgo que solo comparte una de las plántulas con el adulto.',
        correctAnswerAnimal:
      'Esta es la respuesta correcta. Tanto el adulto como la cría de *PARENT_NAME* tienen *TRAITS*.',
    },
    Landforms: {
        title: 'El mapa de Río de Janeiro',
        welcome: 'Disfruta de tu visita a Río de Janeiro',
        clickPin:
      '¡Haz clic en los marcadores para averiguar más sobre cada lugar!',
        start: 'Comenzar',
        show: '¡Show to flow of matter and nutrients through the system!',
        ChristTheRedeemerStatue: 'Estatua del Cristo Redentor',
        ChristRedeemerDescription:
      'Se trata de una estatua gigante construida en la cima de una montaña, junto a la ciudad de Río de Janeiro. La estatua es famosa en el mundo entero y se ve desde muy lejos.',
        RodrigoDeFreitasLagoon: 'Laguna Rodrigo de Freitas',
        LagoonDescription:
      'En la ciudad de Río de Janeiro hay un gran lago al que llamamos «laguna costera». Es una laguna costera y no una «bahía», porque está separada del mar por un fino cordón de tierra.',
        CopacabanaBeach: 'Playa de Copacabana',
        CopacabanaDescription:
      'Esta es una playa famosa en el mundo entero a la que va la gente para disfrutar del sol y relajarse a la orilla del mar.',
        RioNiteroiBridge: 'Puente Río-Niterói',
        BridgeDescription:
      'Este enorme puente atraviesa la bahía de Guanabara y es el sexto puente más largo del mundo. Conecta la ciudad de Río de Janeiro por un lado con la ciudad de Niterói por el otro.',
        MorroDoisIrmaos: 'Morro Dois Irmãos',
        MorroDescription:
      'El Morro Dois Irmãos se conoce como el cerro de los Dos Hermanos en español. Tiene unas de las vistas más impresionantes de Río de Janeiro. Desde la cima del cerro se ven la estatua del Cristo Redentor, la laguna Rodrigo de Freitas y la playa de Copacabana.',
    },
    MakingChangesEcosystem: {
        Algae: 'Algas',
        DecreaseNumber: 'Disminuir la cantidad',
        KeepTheSame: 'Mantener la cantidad',
        IncreaseNumber: 'Aumentar la cantidad',
        AlgaeDescription:
      'Las algas son plantas diminutas que viven en el agua. Obtienen su materia de agua y aire, y su energía del sol.',
        InsectLarvae: 'Larvas de insectos',
        InsectLarvaeDescription:
      'Muchos insectos ponen sus huevos en el agua, y los jóvenes insectos, llamados larvas, viven en el agua antes de transformarse en insectos adultos. Estas larvas de insectos obtienen su materia y energía al comer <b>algas</b>.',
        NativeTrout: 'Truchas nativas',
        NativeTroutDescription:
      'Las truchas nativas viven en lagos, ríos y arroyos, y nadan río arriba cada año para reproducirse. Obtienen su materia y energía al comer <b>larvas de insectos</b>.',
        NonNativeTrout: 'Truchas no nativas',
        NoLakeTrout: 'Ninguna trucha lacustre',
        AddLakeTrout: 'Añadir truchas lacustres',
        AddMoreLakeTrout: 'Añadir más truchas lacustres',
        NonNativeTroutDescription:
      'Estas truchas no nativas viven en el fondo del lago, por lo que no son comidas por los osos. Crecen mucho más que las truchas nativas. Comen tanto <b>larvas de insectos</b> como <b>truchas nativas</b>.',
        Bear: 'Osos',
        BearDescription:
      'Estos osos pescan en los arroyos para alimentarse. Obtienen materia y energía al comer <b>truchas nativas</b>.',
        GoingUp: 'aumentan',
        NoActionPossible: 'No se puede cambiar',
        ChangesInOrganisms:
      '¿Qué ocurre cuando cambia el número de organismos en un ecosistema?',
        IntroducingNonNative:
      '¿Cómo afecta a un ecosistema la introducción de un organismo no nativo?',
    },
    PlantFactory: {
        fruit: 'fruto',
        flower: 'flor',
        leaf: 'hoja',
        stem: 'tallo',
        root: 'raíz',
        strawberry: 'fresa',
        plumTree: 'ciruelo',
        pumpkin: 'calabaza',
        yellowPondLily: 'nenúfar amarillo',
        tomato: 'tomate',
        oregonGrape: 'mahonia',
        crazyPlant: 'planta disparatada',
        team: 'equipo',
        plant: 'planta',
        help: 'Ayuda',
        step1:
      '1. Escribe el nombre de tu equipo en la casilla y haz clic en aceptar.',
        step2: '2. Elige una planta.',
        step3:
      '3. Arrastra y coloca las partes de la planta para crear tu modelo. Cuando termines el modelo, usa las palabras para etiquetar cada parte.',
        step4: '4. Selecciona descargar para guardar tu modelo.',
        step5:
      '5. Selecciona atrás para volver al menú principal. Si tienes tiempo, elige y crea otra planta.',
        plantFactory: 'la fábrica de plantas',
        typeTeamName: 'escribe el nombre de tu equipo:',
        ok: 'Aceptar',
        choosePlant: 'elige una planta',
        download: 'descargar',
    },
    SafariSounds: {
        Tiget: 'Tigre',
        Frog: 'Rana',
        Elephant: 'Elefante',
        Snake: 'Serpiente',
        Parrot: 'Loro',
        Monkey: 'Mico',
        Bee: 'la abeja',
        Human: 'Ser humano',
        title: 'Los sonidos del safari',
        help: 'Ayuda',
        guessText:
      'Los alumnos deben adivinar a qué corresponde cada sonido.',
        playOnce:
      'Haga clic en "Reproducir una vez" para reproducir el sonido una vez.',
        playLoop:
      'Haga clic en "Reproducir en bucle" para reproducir el sonido continuamente.',
        pause: 'Haga clic en el icono Detener para detener la reproducción.',
        answerReveal:
      'Cuando los alumnos adivinen a qué corresponde el sonido, haga clic en la imagen para descubrir la respuesta.',
        whatAnimal: '¿Qué hizo ese sonido?',
        reset: 'Reiniciar',
        sure: '¿Seguro que desea reiniciar?',
        yes: 'Sí',
        no: 'No',
        btnPlayOnce: 'Reproducir una vez',
        btnPause: 'Detener',
        btnPlayLoop: 'Reproducir en bucle',
        btnPauseLoop: 'Detener',
        roar: '[rugido]',
        croak: '[croar]',
        toot: '[barrito]',
        squak: '[graznido]',
        whoop: '[chillido]',
        buzz: '[zumbido]',
        laugh: '[risa]',
        hiss: '[siseo]',
    },
    AnimalSounds: {
        title: 'Sonidos',
        helpTitle: 'Ayuda',
        helpText1:
      'Los alumnos deben adivinar a qué corresponde cada sonido.',
        helpText2:
      'Haga clic en «Reproducir una vez» para reproducir el sonido una vez.',
        helpText3:
      'Haga clic en «Reproducir en bucle» para reproducir el sonido continuamente.',
        helpText4: 'Haga clic en el icono «Detener» para detener la reproducción.',
        helpText5:
      'Cuando los alumnos adivinen a qué corresponde el sonido, haga clic en la imagen para descubrir la respuesta.',
        headerMain: '¿Qué hizo ese sonido?',
        resetButton: 'Reiniciar',
        resetConfirm: '¿Seguro que desea reiniciar?',
        modalResetConfirm: 'Sí',
        modalResetNo: 'No',
        playOnce: 'Reproducir una vez',
        pause: 'Detener',
        playLoop: 'Reproducir en bucle',
        pauseLoop: 'Detener',
        lion: 'León',
        cat: 'Gato',
        dolphin: 'Delfín',
        rattlesnake: 'Serpiente de cascabel',
        frog: 'Rana',
        cricket: 'Grillo',
        wolf: 'Lobo',
        human: 'Ser humano',
        roaring: '[rugido]',
        whistling: '[silbido]',
        meow: '[maullido y ronroneo]',
        rattling: '[siseo]',
        croaking: '[croar]',
        chirping: '[canto]',
        howling: '[aullido]',
        laughing: '[risa]',
    },
    CertificateOfMaterials: {
        title: 'Certificado de Materiales',
        back: 'Atrás',
        next: 'Siguiente',
        caption: '[música alegre]',
        juniorResearcher: 'Becario de investigación',
        JRTask1: 'Describir los objetos según sus propiedades.',
        JRTask2: 'Agrupar los objetos dependiendo de sus propiedades.',
        JRTask3: 'Comparar y contrastar las propiedades de dos objetos.',
        technicianTesting: 'Técnico de testeo',
        TTTask1:
      'Probar distintos materiales para determinar las propiedades de dureza, flexibilidad, impermeabilidad y resistencia.',
        TTTask2:
      'Clasificar los materiales por orden de cuánto muestran una propiedad.',
        TTTask3: 'Elegir los mejores materiales para un fin determinado.',
        engineerExcellence: 'Ingeniero del ingenio',
        EETask1: 'Construir torres de tres materiales distintos.',
        EETask2: 'Comprobar la resistencia de tus torres.',
        EETask3: 'Escribir un informe sobre los resultados de tu prueba.',
        laboratoryLeader: 'Líder de laboratorio',
        LLTask1: 'Dar ejemplos de cambios reversibles e irreversibles.',
        LLTask2:
      'Explicar cómo se hace algo con los términos «sólido», «líquido», «fusión» y «solidificación».',
        LLTask3:
      'Resolver un problema relacionado con los cambios reversibles e irreversibles.',
        professorProperties: 'Profesor de propiedades',
        PPTask1: 'Construir dos puentes distintos con los mismos materiales.',
        PPTask2: 'Comprobar la resistencia de los puentes.',
        PPTask3: 'Comparar los resultados de las pruebas de los puentes.',
    },
    AnimalLifeCycle: {
        title: 'Ciclos de vida de los animales',
        reset: 'Reiniciar',
        check: 'Comprobar',
        caption: '[música feliz con campanas]',
        congratulations:
      'Enhorabuena. Seleccionaste el ciclo de vida correcto para este animal.',
        Amphibians: {
            title: 'Anfibios',
            frog: 'Rana',
            frogSubtitle:
        'Arrastra las imágenes y las etiquetas a los lugares correctos del ciclo de vida de la rana.',
            eggs: 'Huevos',
            embryo: 'Embrión',
            tadpole: 'Renacuajo',
            froglet: 'Rana joven',
            findMate: 'Se aparea',
            newt: 'El tritón',
            newtSubtitle:
        'Arrastra las imágenes y las etiquetas a los lugares correctos del ciclo de vida del tritón.',
            layEggs: 'Pone huevos',
            developingEggs: 'Desarrollo de los huevos',
            gilledLarvae: 'Larva con branquias',
            adult: 'Adulto',
        },
        Birds: {
            title: 'Aves',
            cassowary: 'El casuario',
            cassowarySubtitle:
        'Arrastra las imágenes y las etiquetas a los lugares correctos del ciclo de vida del casuario.',
            hatchling: 'Polluelo recién nacido',
            eggsHatch: 'Los huevos eclosionan',
            layEggs: 'Pone huevos',
            incubateEggs: 'Incuba los huevos',
            findMate: 'Se aparea',
            hummingbird: 'El colibrí',
            hummingbirdSubtitle:
        'Arrastra las imágenes y las etiquetas a los lugares correctos del ciclo de vida del colibrí.',
            adult: 'Adulto',
        },
        Reptiles: {
            title: 'Reptiles',
            lizard: 'El lagarto',
            lizardSubtitle:
        'Arrastra las imágenes y las etiquetas a los lugares correctos del ciclo de vida del lagarto.',
            youngLizard: 'Lagarto joven',
            egg: 'Huevo',
            hatchling: 'Lagarto recién nacido',
            adult: 'Adulto',
            findMate: 'Se aparea',
        },
    },
    MediaGallery: {
        title: 'Galería multimedia',
        heading: 'Galería multimedia: reversible e irreversible',
        juice: 'Jugo',
        egg: 'Huevo',
        butter: 'Mantequilla',
    },
    EarthChanges: {
        caption: 'Subtítulos en',
        earthChanges: 'Cambios en la Tierra',
        title: 'Galería multimedia de cambios en la Tierra',
        buttonText1: 'RÁPIDOS O LENTOS',
        buttonText2: 'SOLUCIONES A LA EROSIÓN',
        quickOrSlow: 'Rápidos o lentos',
        volcanicEruption: 'Erupción volcánica',
        video: 'Video',
        textWithPhotos: 'Texto con fotos',
        eruptionMtStHelen: 'Erupción del monte Santa Helena',
        lavaFlow: 'Colada de lava',
        eruptionTungarahua: 'Erupción del Tungurahua',
        description1:
      '<ul><li>Un volcán es una abertura en la corteza terrestre por la cual se expulsan o vierten roca fundida y gases. Hay volcanes en la tierra y también en el océano. La erupción de los volcanes ocurre cuando aumenta la presión en el interior de la Tierra. Los volcanes entran en erupción de distintas maneras. Algunas erupciones son muy fuertes y expulsan lava ardiente al aire. También pueden expulsar rocas, gas caliente y ceniza. En algunos casos, la colada de lava fluye lentamente por la abertura en la corteza terrestre. El volcán Kilauea de Hawái expulsa lava lentamente por varias aberturas en la corteza terrestre.</li><li><br>Todos los volcanes son peligrosos. Pueden cambiar paisajes enteros en unos pocos días, horas o incluso minutos. Hace mucho tiempo se produjo una erupción de ese tipo en Roma. El monte Vesubio entró en erupción. Expulsó lava ardiente, gas y rocas que se deslizaron por la ladera de la montaña y cubrieron la ciudad vecina de Pompeya. Tardaron poco más de un día en cubrirla. Muchos de los habitantes de Pompeya no lograron escapar a tiempo. Quedaron sepultados por las rocas y la ceniza.</li></ul>',
        flashFlood: 'Inundación repentina',
        photos: 'Fotos',
        floodedHouse: 'Casa inundada',
        floodedRoad: 'Carretera inundada',
        floodedTown: 'Pueblo inundado',
        landslide: 'Desprendimiento de tierras',
        glacierValleyFormation: 'Formación de valles glaciares',
        glacierValley: 'Glaciar en un valle',
        largeValley: 'Gran valle',
        mountainGlacier: 'Glaciar en la montaña',
        description2:
      '<ul><li>Los glaciares son grandes ríos de hielo sólido que se deslizan lentamente por la ladera de una montaña. Solo hay glaciares en los lugares de la Tierra donde las temperaturas son muy frías. Hace mucho tiempo, había glaciares por toda la Tierra. Los científicos lo saben por la forma de los valles y los cañones. Comparan esas formas con las zonas donde todavía hay glaciares. Los glaciares tardan miles de años en excavar valles en la Tierra.</li><li><br>Podríamos decir que los glaciares son el bulldozer natural más potente del planeta. La fuerza de la gravedad y la presión hacen que los grandes ríos de hielo se deslicen muy lentamente montaña abajo. El glaciar va incorporando rocas y sedimentos. Al avanzar el glaciar, arrastra esas rocas por la superficie. Van erosionando el terreno. El glaciar es como un papel de lija enorme que rasca y desgasta la Tierra. Cuando el glaciar llega hasta un punto más cálido, se derrite. Deposita las rocas y los sedimentos. El hielo derretido va a parar a los lagos, ríos y océanos. Después de muchos años moviéndose, derritiéndose y esculpiendo la tierra, el hielo crea un profundo valle. Así termina el trabajo del glaciar.</li></ul>',
        weatheringAndErosion: 'Meteorización y erosión',
        windErosionRocks: 'Rocas erosionadas por el viento',
        description3:
      '<ul><li>El paisaje de la Tierra tarda largo tiempo en cambiar. El agua, el viento, las plantas y los animales meteorizan y erosionan las superficies terrestres. La meteorización se produce cuando las rocas se parten en fragmentos más pequeños. La erosión ocurre cuando esos fragmentos más pequeños se trasladan. Al trasladarse los fragmentos, rascan la superficie por la que se mueven.</li><li><br>Algunos de estos cambios los producen el agua o el viento. El agua —al llover, correr, congelarse o fundirse— desgasta la superficie terrestre. El viento, cuando sopla, erosiona la superficie de las rocas. Las masas de tierra se rompen poco a poco.</li><li><br>El viento y el agua las trasladan o les añaden más material.</li><li><br>La meteorización y la erosión a veces crean arcos o altas torres de roca llamadas chimeneas de hadas. Las chimeneas de hadas tardan millones de años en formarse.</li><li>A muchas personas les gusta observar estas formaciones rocosas, por ejemplo, cuando visitan los parques nacionales. Si vuelven al mismo sitio años más tarde, es posible que ni siquiera noten los cambios. Los efectos de la erosión son casi imperceptibles.</li></ul>',
        erosionSolutions: 'Soluciones a la erosión',
        erosionEngineering: 'Soluciones de ingeniería',
        levee: 'Dique de contención',
        description4:
      '<ul></li>El agua, a su paso, erosiona el terreno a ambos lados del río. El río se ensancha y el agua desgasta las riberas. Con el paso del tiempo, las riberas pueden ensancharse tanto que cambia el curso del río. Cuando cambia el curso del río, se inunda un nuevo terreno... ¡que puede tener carreteras o edificios! Otro problema del desgaste de las riberas es que el agua del río puede llegar a saltarlas. Eso provoca inundaciones. La construcción de diques de contención a lo largo de las riberas puede prevenir esa erosión. Los diques de contención son grandes estructuras que se construyen a lo largo de los ríos y las costas. Suelen estar formadas de grandes montañas de tierra. Son anchas en la base y más estrechas en la parte superior, y forman una pendiente que se aleja del río. Los diques forman un «muro» largo e inclinado a lo largo del río o la costa. Ayudan a prevenir las inundaciones. Los diques evitan que el río se ensanche. Impiden el desgaste de las riberas para retener el agua y evitar las inundaciones.</li><li><br>Los diques protegen contra la erosión, pero también pueden sufrir la erosión del río, la lluvia y el viento. Los diques se pueden romper si la erosión los debilita en exceso. Por ejemplo, si se produce una gran inundación y el agua viene con mucha fuerza, el dique puede ser incapaz de contenerla. Se pueden plantar pastos, árboles y arbustos sobre el dique para reforzarlo. Las raíces de las plantas ayudan a sujetar la tierra del dique. A veces, las raíces de las plantas no son lo bastante fuertes para sujetar el dique. En ese caso, se pueden utilizar otros materiales de construcción para proteger el dique. Se pueden usar materiales como hormigón, rocas o piedras grandes.</li><li><br>El principal problema de construir diques es su coste. Hace falta mucho trabajo, tiempo y trabajadores para construir un dique a lo largo de un río o la costa. Cuesta mucho dinero pagar a todos esos trabajadores.</li><li><br>Dato curioso: En el antiguo Egipto, la gente construía diques en las riberas del río Nilo.</li></ul>',
        breakwater: 'Escollera o rompeolas',
        description5:
      '<ul></li>En algunas costas se construyen rompeolas o escolleras. Protegen la costa de la erosión de las olas. También pueden protegerla de la erosión del viento y de la lluvia. Los rompeolas son grandes estructuras. Están hechos de piedras enormes y pesadas. Se parecen un poco a un gran muro de piedra. Se construyen en zonas poco profundas del mar. Los rompeolas pueden tener un solo muro de piedra largo. También pueden tener varios muros de piedra más pequeños.</li><li><br>Los rompeolas ayudan a frenar las olas. Hacen que las olas disminuyan de tamaño antes de alcanzar la orilla. A veces, si se produce una gran tormenta, no es posible cortar el paso a las olas más grandes. Los rompeolas también son útiles para detener el movimiento de la arena por el fondo marino. Cuando las olas alcanzan la playa, pueden arrastrar la arena y llevársela. Eso hace que la playa se erosione. Los rompeolas frenan las olas y evitan que la arena arrastrada llegue demasiado lejos. Algunas personas consideran que los rompeolas son feos y que estropean las vistas.</li></ul>',
        seawall: 'Malecón',
        description6:
      '<ul></li>En la costa, la marea alta puede provocar inundaciones. Las olas más fuertes pueden ser peligrosas. Pueden dañar las carreteras y los edificios. En muchas zonas bajas se construyen malecones para proteger la costa. Los malecones suelen estar hechos de hormigón, rocas grandes o acero. Son muy altos, ¡mucho más altos que tú! Los malecones protegen la costa evitando que las olas alcancen la orilla. </li><li><br>La costa cambia constantemente por la erosión de las olas, los ríos, el viento y la lluvia. Para proteger la costa de la erosión, los malecones tienen que ser muy grandes. Es decir, que ocupan mucho espacio. Pueden ocupar el espacio de las plantas y los animales que viven en la orilla. </li><li><br>Los malecones son resistentes y pueden durar mucho tiempo. ¡Algunos malecones construidos por los romanos hace más de 2,000 años todavía resisten hoy en día! Sin embargo, las olas grandes pueden dañar los malecones durante las tormentas. Hay que revisarlos periódicamente después de las tormentas. Puede ser muy caro construir y mantener los malecones. Si la línea de costa es muy larga, se necesitan muchos materiales de construcción para construir el muro.</li></ul>',
        retainingWall: 'Muro de contención',
        description7:
      '<ul></li>La erosión del viento y de la lluvia puede ser un problema en los terrenos accidentados. Las fuertes lluvias pueden arrastrar el suelo de la ladera de una montaña hasta el valle. La lluvia puede llevarse los caminos o bloquearlos con tierra. Las rocas subterráneas pueden debilitarse y desprenderse a causa de la erosión constante. Las rocas, el suelo y el barro pueden deslizarse por la ladera cuando se produce un desprendimiento de tierras. Es peligroso porque las rocas y la tierra sueltas podrían chocar contra los edificios, las carreteras e, incluso, las personas.</li><li><br>En las laderas se construyen muros de contención para evitar que el suelo se deslice hacia abajo. Los muros de contención son estructuras sólidas. Suelen estar hechos de hormigón, piedra, metal o madera. Se construyen como los muros de las casas, pero son mucho más gruesos. Eso ayuda a sujetar la tierra de la ladera que tienen detrás. Se pueden construir varios muros de contención uno detrás de otro por toda la ladera. Muchos de los muros construidos uno tras otro parecen una escalera gigante cuando los miras desde abajo de la ladera. El espacio que hay entre los muros se puede rellenar de tierra y allanarla para que las plantas no se deslicen ladera abajo. </li><li><br>Otra manera de proteger una ladera es cubriéndola con una red de contención para evitar la erosión. Las redes de contención están hechas de fibras naturales o de plástico. La red se usa para cubrir el suelo. Eso evita que el viento se lo lleve. Las redes de contención también limitan la erosión de la lluvia. Cuando el agua de lluvia baja por una ladera, puede arrastrar el suelo. Con una red de contención, se puede frenar el agua y evitar que arrastre tanta tierra ladera abajo. </li><li><br>Los muros y las redes de contención pueden ser muy útiles. Algunas personas consideran que estropean el aspecto de las laderas. Si se produce un desprendimiento de tierras muy grande, los muros y las redes pueden romperse.</li></ul>',
        naturalSolutions: 'Soluciones naturales',
        breachNourishment: 'Regeneración de playas',
        description8:
      '<ul></li>La erosión del viento, la lluvia y las olas arrastra la arena de algunas zonas. Una manera de solucionar este problema es volver a añadir arena donde ha desaparecido. Eso permite que la erosión continúe sin provocar demasiados daños a la playa. La erosión es constante, por lo que hay que reemplazar la arena con frecuencia. Es un trabajo que lleva mucho tiempo.</li><li><br><br>Las dunas de arena son una forma natural de proteger las playas de la erosión. Se forman cuando el viento arrastra la arena y la amontona en una misma área. Con el tiempo, se amontona cada vez más arena y las dunas se agrandan. Las dunas son muy útiles para frenar el viento o el agua que podrían arrastrar la arena, las rocas o la tierra. Las dunas tardan mucho tiempo en formarse por sí solas. Una forma de proteger las playas de la erosión es imitar a la naturaleza y construir dunas de arena nosotros mismos. Hace falta mucho material para construir dunas lo bastante grandes para proteger frente a la erosión. Para eso, tenemos que mover mucha arena de un lugar a otro. Puede llevarnos mucho tiempo.</li></ul>',
        managedRetreat: 'Retirada controlada',
        description9:
      '<ul></li>Una posible solución si la erosión se convierte en un gran problema es trasladar a todas las personas de esa zona. Es lo que llamamos una «retirada controlada». Cuando se van todas las personas, las inundaciones o la erosión de la costa se producen sin correr riesgos. La retirada controlada es la opción que menos daños causa al medio ambiente. Sin embargo, la retirada controlada puede ser difícil porque hay que buscar nuevos hogares para las personas que vivían en esa zona.</li><li><br><br>A las personas trasladadas de esa zona ya no les afectará la erosión del viento, la lluvia, los ríos o las olas. Por otra parte, los edificios abandonados de esa zona no podrán volver a usarse. En las zonas costeras, se puede dejar que costa avance hacia el interior y los edificios vacíos pueden hundirse en el mar. La retirada controlada se suele hacer en zonas que sufren problemas de erosión muy graves. Se usa cuando ya se han probado otras soluciones que no han funcionado. Se suele hacer en zonas muy bajas o cercanas al océano. En ellas es donde existe un gran riesgo de inundaciones.</li></ul>',
        sandDuneVegetation: 'Vegetación de las dunas',
        description10:
      '<ul></li>Los vientos fuertes pueden empujar el suelo ladera abajo. Las fuertes lluvias pueden arrastrarlo. Una solución es plantar pasto y otras plantas. Las raíces sujetan el suelo y ayudan a protegerlo. Las raíces de las plantas y los pastos en las playas pueden ayudar a sujetar la arena de las dunas. Si se sujeta la arena, las dunas estarán mejor protegidas de los vientos fuertes, la lluvia y las olas. Las raíces sujetan el suelo bajo tierra. La parte superior de las plantas puede frenar el agua y las ráfagas de viento. El agua y el viento no pueden arrastrar tanto suelo ni arena cuando avanzan más lentamente. </li><li><br><br>Cuantas más plantas hay en una ladera o en una duna de arena, más raíces crecen en la tierra. Las raíces sujetan el suelo y lo protegen de la erosión. Muchas plantas y pastos son frágiles y se dañan con facilidad. Las fuertes lluvias y el oleaje pueden arrancar las plantas si se produce una gran tormenta. En ese caso habrá que volver a plantarlas.</li></ul>',
        windbreaks: 'Cortavientos',
        description11:
      '<ul></li>Los agricultores suelen necesitar amplios terrenos abiertos para plantar sus cultivos. Es difícil evitar que el viento se lleve el suelo en esos terrenos. Si el viento se lleva el suelo, los agricultores no pueden plantar sus cultivos. Se pueden plantar hileras de árboles en los campos o las llanuras como «cortavientos» para proteger el suelo. Los árboles ayudan a frenar el viento para que no sea tan fuerte. Así el viento no podrá llevarse tanta tierra. Los cortavientos protegen de la erosión del viento.</li><li><br><br>El principal problema de plantar árboles como cortavientos es que tardan mucho tiempo en crecer. Los árboles más altos tapan más espacio y son mejores para frenar el viento. Los mejores cortavientos suelen tener una mezcla de distintas especies de árboles. Son los mejores porque los árboles tienen tamaños distintos. Los árboles más bajos sirven para tapar los huecos entre los árboles más altos. Así los árboles están muy juntos y frenan mejor el viento para proteger esas zonas de la erosión.</li></ul>',
    },
    MakingWaves: {
        title: 'Making Waves',
        hotspot1: 'La roca caerá desde acá',
        hotspot2a: 'Pon',
        hotspot2b: 'la roca acá',
        description1a: 'Arrastra el pato hasta el punto ',
        description1b: 'A, B',
        description1c: ' o ',
        description1d: 'C.',
        description2: 'Elige el tamaño de la roca que dejarás caer:',
        description3: '¡Allá va!',
        description4part1: 'Tus resultados:',
        description4part2: 'Posición del pato:',
        description4part3: 'Tamaño de la roca:',
        description4part4: 'Altura de la onda:',
        caption: '[chapoteo de agua]',
        next: 'Siguiente',
        small: 'Pequeña',
        large: 'Grande',
        drop: '¡Suéltala!',
        startOver: 'Repetir',
    },
    EarthMap: {
        title: 'Earth Map',
        lake: 'Lago',
        snow: 'Hielo/nieve',
        river: 'Río',
        ocean: 'Océano',
        tip: 'Consejo: Para eliminar un marcador, púlsalo dos veces.',
    },
    TimeLapse: {
        timeLapse: 'Secuencias de imágenes',
        welcomeTour: 'Descubre estas secuencias temporales de imágenes',
        start: 'Comenzar',
        videoTitle: '!!Video title',
        columbiaGlacier: '1. Glaciar Columbia, AK, EE. UU.',
        amazon: '4. Selva amazónica, Rondonia, Brasil',
        padma: '7. Río Padma, Bangladés',
        mountStHelens: '2. Monte Santa Helena, WA, EE. UU.',
        dubai: '5. Dubái, Emiratos Árabes Unidos',
        yellowRiverDelta: '8. Delta del río Amarillo, China',
        capeCod: '3. Cabo Cod, MA, EE. UU.',
        aralSea: '6. Mar de Aral, Kazajistán y Uzbekistán',
        shanghai: '9. Shanghái, China',
        credit: 'Crédito: Observatorio de la Tierra de la NASA',
    },
    SolarCooker: {
        smallBox: 'Una caja pequeña',
        wedge: 'Cuña',
        cone: 'Cono',
        cylinder: 'Cilindro',
        umbrella: 'Paraguas',
        whitePaper: 'Papel blanco',
        cardboard: 'Cartón',
        wood: 'Madera',
        aluminumFoil: 'Papel de aluminio',
        white: 'Blanca',
        lightGray: 'Gris claro',
        darkGray: 'Gris oscuro',
        black: 'Negro',
        choose: 'Elige...',
        timeMinutes: '*TIME* minutos',
        solarCooker: 'Cocina solar',
        howCook: '¿Cómo puedes cocinar con la energía del Sol?',
        designSolarCooker:
      'Tienes que elegir una combinación de colores, formas y materiales para diseñar una cocina solar para hervir agua. ¡La mejor combinación conseguirá que el agua hierva antes!',
        chooseFollowing: 'Elige lo siguiente:',
        typeOfCooker: '1 - El tipo de cocina.',
        interiorType:
      '2 - El tipo de material para las paredes del interior de la cocina.',
        colorOfCan: '3 - El color de la lata que contendrá el agua.',
        pressStart:
      'Cuando los hayas elegido, haz clic en «Comenzar» para ver cuánto tiempo tarda tu cocina solar en hervir el agua.',
        heating: 'Se está calentando...',
        instructions: 'Instrucciones:',
        chooseOptions:
      'Elige una combinación de las opciones siguientes y descubre cuánto tarda en hervir el agua.',
        cooker: 'Tipo de cocina',
        interior: 'Tipo de material',
        color: 'Color de la lata',
        youChose: 'Elegiste:',
        largeBox: 'Una caja grande',
        woodInterior: 'Interior de madera',
        whiteCan: 'Lata blanca',
        yourSolarCooker: 'Tu cocina solar tardó en hervir el agua:',
        minutes: '107 minutos',
        reset: 'Reiniciar',
        startOver: 'Empezar de nuevo',
        start: 'Comenzar',
    },
    WeatherAnalyzer: {
        title: 'Analizador del tiempo',
        yuma: 'Yuma, Arizona',
        minneapolis: 'Mineápolis, Minesota',
        mobile: 'Mobile, Alabama',
        apr: 'abr',
        jun: 'jun',
        jul: 'jul',
        avgMonthlyTemp: 'Temperatura mensual promedio',
        avgMonthlyPrecip: 'Precipitación mensual promedio',
        avgPrecipMm: 'Precipitación promedio (mm)',
        avgMonthlyWind: 'Velocidad del viento mensual promedio',
        avgWindKmHr: 'Velocidad del viento promedio (km/h)',
        diffTempDegrees:
      'La diferencia entre la temperatura máxima y la mínima es de *DIFF* grados.',
        diffWindKmHr:
      'La diferencia entre la velocidad máxima y la mínima es de *DIFF* km/h.',
        diffPrecipMm:
      'La diferencia entre la mayor y la menor precipitación es de *DIFF* mm.',
        chooseLocation: 'Elige un lugar',
        chooseDataType: 'Elige el tipo de datos:</div>',
        for: 'en',
        chooseLocationAndData:
      'Elige un lugar y el tipo de datos del tiempo que quieres observar. Luego haz clic en «Comenzar».',
        start: 'Comenzar',
        avgMonthlyTempMinneapolis: 'Precipitación media mensual en Mineápolis, MN',
        avgTempF: 'Temperatura promedio (&deg;F)',
        jan: 'ene',
        feb: 'feb',
        mar: 'mar',
        april: 'abril',
        may: 'may',
        june: 'jun',
        july: 'jul',
        aug: 'ago',
        sep: 'sep',
        oct: 'oct',
        nov: 'nov',
        dec: 'dic',
        enterYourData: 'Escribe tus datos:',
        calculateRange: 'Calcular el rango',
    },
    IceAge: {
        title: 'Sobrevivir a una glaciación',
        nextPeriod: 'Siguiente período',
        startOver: 'Empezar de nuevo',
        periodTime: 'Período *TIME_PERIOD*',
        iceAgeSurvival: 'Sobrevivir a una glaciación',
        averageTempDesc:
      'La temperatura media durante la glaciación era 12 grados más fría que la media actual. Por eso, incluso en los lugares donde crecían bosques y pastos hacía mucho más frío que hoy en día. Cuando cambia la temperatura del planeta, también cambia el hábitat en el que viven los animales y las plantas. Eso dificulta la supervivencia. ¿Puedes ayudar a estos animales a sobrevivir a la glaciación?',
        start: 'Comenzar',
        dragAnimals:
      'Arrastra animales al mapa para ver cómo sobreviven a los cambios climáticos.',
        mammoths: 'Mamuts',
        squirrels: 'Ardillas',
        addHumans: 'Añadir seres humanos',
        startSimulation: 'Comenzar la simulación',
        legend: 'Leyenda:',
        glacier: 'Glaciar',
        forest: 'Bosque',
        shrubs: 'Matorral',
        grass: 'Pasto',
        desert: 'Desierto',
        lakeTrout: 'Trucha lacustre',
        playSimulation: 'Iniciar simulación',
        reset: 'Reiniciar',
        goingDown: 'disminuyen',
        startOverConfirm: '¿Seguro que quieres empezar de nuevo?',
        yes: 'Sí',
        no: 'No',
    },
    SpaceAdventure: {
        caption: '[happy music playing]',
        title: 'Space Adventures',
        next: 'Next',
        back: 'Back',
        knowSeeSunDay: 'I know I can see the Sun during the day.',
        knowSeeMoonNight: 'I know I can see the Moon at night.',
        nameObjectsSky: 'I can name other objects in the sky.',
        rocketLauncher: 'Rocket Launcher',
        knowObjectsSmaller: 'I know that objects farther away look smaller.',
        knowSunFartherMoon: 'I know that the Sun is farther away than the Moon.',
        makeRocketLaunchMoon: 'I can make a rocket and launch it at the Moon!',
        starBlazer: 'Star Blazer',
        nameEightPlanets: 'I can name the 8 planets in the Solar System.',
        makeSolarSystemModel: 'I can make a model of the Solar System.',
        knowPlanetsOrbitSun: 'I know that the planets orbit the Sun.',
        planetHopper: 'Planet Hopper',
        exploreMysteryPlanet: 'I can explore a mystery planet.',
        makeModelVolcano: 'I can make a model volcano.',
        nameRockyPlanets: 'I can name the rocky planets.',
        astronaut: 'Astronaut',
        planSpaceMission: 'I can plan a space mission to a planet.',
        designRocketPlanet: 'I can design a rocket to take me to my planet.',
        knowPlanetsSpaceMission:
      'I know which planets I will see on my space mission.',
    },
    LandformPatterns: {
        water: 'Agua',
        pin: 'Para eliminar un marcador, púlsalo dos veces.',
    },
    AmusementPark: {
        title: 'Parque de diversiones',
        heading: 'Las fuerzas en el parque de diversiones',
        welcomeText:
      'Haz clic en los puntos para averiguar más sobre cada atracción',
        start: 'Comenzar',
        bumperCar: 'Los autos de choque',
        bumperCarDescription:
      'Cuando chocan los autos, estos cambian de dirección y de velocidad. ¿Qué ocurre con las fuerzas que actúan sobre ellos?',
        riverLog: 'Los rápidos',
        riverLogDescription:
      'La velocidad del bote disminuye cuando llega al pie de la pendiente. ¿Las fuerzas que actúan sobre él están en equilibrio o en desequilibrio?',
        rollerCoaster: 'La montaña rusa',
        rollerCoasterDescription:
      '¿Qué le ocurre al movimiento del carro de la montaña rusa cuando desciende la pendiente? ¿Se trata de fuerzas en equilibrio o en desequilibrio?',
        monorail: 'El monorraíl de Divertimundo',
        monorailDescription:
      'El tren monorraíl recorre todo el parque. Los carros se mueven a una velocidad constante. ¿Se trata de fuerzas en equilibrio o en desequilibrio?',
    },
    FoodChain: {
        title: 'Las cadenas alimentarias',
        text1:
      'Muestra el movimiento de la materia y la energía por todo el sistema.',
        text2:
      'Arrastra los organismos y las flechas de la energía y la materia al recuadro central en el orden correcto.',
        text2a: 'Puedes colocar hasta dos flechas entre cada.',
        text3:
      'Cuando termines, selecciona "Comprobar" para comprobar tu respuesta. ',
        text5: 'Si quieres volver a empezar, selecciona "Reiniciar"',
        reset: 'Reiniciar',
        start: 'Comenzar',
        energy: 'Energía',
        matter: 'Materia',
        check: 'Comprobar',
        twinkle: '[música feliz con campanas]',
        controlLabel: 'Nivel',
        notification: '¡Buen trabajo! Ahora prueba con otra cadena alimentaria.',
        errorNotification: 'Intentar otra vez.',
        introSubTitle:
      'Arrastra los organismos y las flechas en el orden correcto para mostrar el movimiento de la materia y la energía por todo el sistema',
        pineForestFoodChain: 'Cadena alimentaria del pinar',
        dragText:
      'Arrastra las imágenes y las flechas en el orden correcto. Puede haber una o dos flechas entre cada imagen.',
        helpTitle: 'Ayuda',
        sun: 'El Sol',
        plant: 'Planta',
        mouse: 'Ratón',
        eagle: 'Águila',
        oceanFoodChain: 'Cadena alimentaria del océano',
        algae: 'Algas',
        scallop: 'Vieira',
        harborSeal: 'Foca común',
        orcaWhale: 'Orca',
        oakWoodlandFoodChain: 'Cadena alimentaria del robledal',
        grass: 'Pasto',
        cricket: 'Grillo',
        frog: 'Rana',
        owl: 'Búho',
    },
    VirtualMicroscope: {
        title: 'Un microscopio virtual',
        introText:
      '¡Ponte la bata de laboratorio para observar muy de cerca a los seres vivos! Con el microscopio virtual de Twig podrás ver más de cerca de qué están hechos realmente los seres vivos. Tal vez creas que sabes cómo son las plantas y los animales, ¡pero todo es muy diferente visto al microscopio!',
        getReadyText:
      'Prepárate para explorar las partes que forman las plantas y los animales, incluso los seres humanos. ¡Hasta podrás descubrir si hay algún parecido entre tu cerebro y el de una rata!',
        start: 'Comenzar',
        slideCaption: '[sonido de colocar portaobjetos]',
        zoomCaption: '[sonido del revólver del microscopio]',
        selectSample:
      'Elige una muestra de los cajones y arrástrala al microscopio para empezar.',
        clear: 'Quitar',
        viewSlide: 'Ver la diapositiva',
        heartMuscle: 'tejido muscular del corazón',
        zoom: 'Nivel de zoom',
        low: 'mínimo',
        high: 'máximo',
        hight: 'máximo',
        humans: 'Seres humanos',
        lung: 'Pulmón',
        alveoli: 'Alvéolos',
        epitheliumTissue: 'Tejido epitelial',
        intestine: 'Intestino',
        smoothMuscleTissue: 'Tejido muscular liso',
        heart: 'Corazón',
        heartMuscleTissue: 'Tejido muscular del corazón',
        brain: 'Cerebro',
        nervousTissueInBrain: 'Tejido nervioso del cerebro',
        otherAnimals: 'Otros animales',
        ratBrainTissue: 'Tejido cerebral de una rata',
        frogLargeIntestineTissue: 'Tejido del intestino grueso de una rana',
        catAlveoli: 'Alvéolos de gato',
        plants: 'Plantas',
        stalk: 'Tallo',
        broccoliStalk: 'Tallo de brócoli',
        root: 'Raíz',
        onionRootTip: 'Punta de la raíz de una cebolla',
        leaf: 'Hoja',
        orchidLeaf: 'Hoja de orquídea',
        microorganisms: 'Microorganismos',
        salmonellaBacteria: 'Bacteria de <i>Salmonella</i>',
        algae: 'Algas',
        amoeba: 'Ameba',
        yeast: 'Levadura',
    },
    Stargazer: {
        title: 'El observatorio de las estrellas',
        introduction:
      'Con el observatorio de las estrellas de Twig podrás observar el cielo estrellado en cualquier momento. Podrás viajar atrás en el tiempo y ver el aspecto que tenían las estrellas hace cientos de años. ¡También podrás viajar al futuro! Selecciona la hora, el día, el mes y el año para ver lo que hacen las estrellas en cualquier momento. ¡Incluso durante el día!',
        explore:
      'Prepárate para explorar las constelaciones, las estrellas que las componen, y cuándo y dónde aparecen en el cielo. ¿Qué patrones observas en el cielo?',
        start: 'Comenzar',
        dateTime: 'Fecha/hora',
        constellations: 'Constelaciones',
        off: 'Ocultar',
        on: 'Mostrar',
        all: 'Todas',
        individual: 'Solo esta',
        virgo: 'Virgo',
        leo: 'Leo',
        lyra: 'Lyra',
        sagittarius: 'Sagitario',
        pegasus: 'Pegaso',
        capricornus: 'Capricornio',
        perseus: 'Perseo',
        cetus: 'Ceto',
        jan: 'Ene',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Abr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Ago',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dic',
        distance: 'Distancia',
        ly: 'a.I',
    },
    WaterConservation: {
        title: 'Ahorro del agua',
        introduction:
      'Hay muchas maneras de ahorrar agua. Seguramente ya conocerás algunas, ¡pero otras quizá te sorprendan!',
        instructions:
      'Mientras recorres la casa, haz clic en los objetos y electrodomésticos de cada habitación para explorar tus opciones para ahorrar agua. ¡Haz clic en el botón <b>«Resumen»</b> al final para ver cuánta agua podrías ahorrar!',
        enterNameTitle: 'Escribe un nombre/título:',
        start: 'Comenzar',
        waterUseSummary: 'Resumen de tu consumo de agua',
        item: 'Artículo',
        yourSelection: 'Tu selección',
        avgMonthlyUsage: 'Consumo medio mensual (galones)',
        gallons: 'galones',
        newMonthlyUsage: 'Nuevo consumo mensual (galones)',
        waterConserved: 'Agua ahorrada (galones)',
        cost: 'Coste',
        print: 'Imprimir',
        startAgain: 'Volver a empezar',
        ok: 'Aceptar',
        kitchen: 'Cocina',
        backToKitchen: 'Volver a la cocina',
        kitchenSink: 'Fregadero',
        monthlyUsage1000Gal: 'Consumo mensual: 1,000 galones al mes',
        addAerator: 'Añadir un aireador',
        aeratorDescription:
      'Los aireador reducen la cantidad de agua que sale de la llave.',
        cost5Savings500Gal: 'Coste: 5 $ Ahorro: 500 gal',
        useDishwasher: 'Usa un lavavajillas en vez de lavar a mano',
        dishwasherDescription:
      'El lavavajillas consume menos agua en cada lavado de la que tú necesitas para lavar todos esos trastes a mano.',
        costNoneSavings300Gal: 'Coste: cero Ahorro: 300 gal',
        bothTogether: 'Los dos cambios',
        cost5Savings550Gal: 'Coste: 5 $ Ahorro: 550 gal',
        noChange: 'Ningún cambio',
        dishwasher: 'Lavavajillas',
        monthlyUsage180Gal: 'Consumo mensual: 180 galones al mes',
        newDishwasher: 'Lavavajillas nuevo',
        newDishwasherDescription:
      'Los lavavajillas modernos consumen la mitad de agua que los antiguos.',
        cost500Savings90Gal: 'Coste: 500 $ Ahorro: 90 gal',
        runOnlyFullLoads: 'Úsalo solo cuando esté lleno',
        fullLoadDescription:
      'No uses el lavavajillas si solo tienes unos pocos platos sucios. Espera a que el lavavajillas esté lleno antes de usarlo.',
        costNoneSavings90Gal: 'Coste: cero Ahorro: 90 gal',
        cost500Savings135Gal: 'Coste: 500 $ Ahorro: 135 gal',
        bathroom: 'Baño',
        backToBathroom: 'Volver al baño',
        toBathroom: 'Al baño',
        shower: 'Ducha',
        monthlyUsage6000Gal: 'Consumo mensual: 6,000 galones al mes',
        installLowFlowShowerhead: 'Instala una nueva regadera de bajo consumo',
        lowFlowShowerheadDescription:
      'Las regaderas de bajo consumo usan menos agua pero aún te permiten darte una buena ducha.',
        cost25Savings3000Gal: 'Coste: 25 $ Ahorro: 3,000 gal',
        cutShowerTime: 'Dúchate en la mitad de tiempo',
        cutShowerTimeDescription: 'Si te das prisa en la ducha, ahorrarás agua.',
        costNoneSavings3000Gal: 'Coste: cero Ahorro: 3,000 gal',
        cost25Savings4500Gal: 'Coste: 25 $ Ahorro: 4,500 gal',
        toilet: 'Inodoro',
        monthlyUsage3000Gal: 'Consumo mensual: 3,000 galones al mes',
        installLowFlowToilet: 'Instala un nuevo inodoro de bajo consumo',
        lowFlowToiletDescription:
      'Los inodoros de bajo consumo usan mucho menos agua por descarga que los inodoros normales.',
        cost500Savings2232Gal: 'Coste: 500 $ Ahorro: 2,232 gal',
        waterBottleInToilet: 'Coloca una botella de agua en el tanque del inodoro',
        waterBottleDescription:
      'Una botella u otro recipiente, colocado en el tanque del inodoro, utiliza menos agua por descarga.',
        bathroomSink: 'Lavabo',
        monthlyUsage1800Gal: 'Consumo mensual: 1,800 galones al mes',
        cost5Savings600Gal: 'Coste: 5 $ Ahorro: 600 gal',
        turnOffWater: 'Apaga el agua mientras te cepillas los dientes',
        turnOffWaterDescription:
      'Si cierras la llave cuando te lavas los dientes, ahorrarás agua.',
        costNoneSavings360Gal: 'Coste: cero Ahorro: 360 gal',
        cost5Savings960Gal: 'Coste: 5 $ Ahorro: 960 gal',
        laundryRoom: 'Lavandería',
        backToLaundryRoom: 'Volver a la lavandería',
        toLaundryRoom: 'A la lavandería',
        washingMachine: 'Lavadora',
        monthlyUsage1500Gal: 'Consumo mensual: 1,500 galones al mes',
        buyNewWasher: 'Compra una lavadora nueva',
        newWasherDescription:
      'Las lavadoras de alta eficiencia usan aproximadamente la mitad del agua que las lavadoras normales.',
        cost600Savings650Gal: 'Coste: 600 $ Ahorro: 650 gal',
        fullLoadWasherDescription:
      'No uses la lavadora si solo tienes unas pocas prendas sucias. Espera hasta que tengas suficiente ropa para una carga completa antes de encenderla.',
        costNoneSavings375Gal: 'Coste: cero Ahorro: 375 gal',
        cost600Savings1000Gal: 'Coste: 600 $ Ahorro: 1,000 gal',
        pipes: 'Tuberías',
        monthlyUsage110Gal:
      'Consumo mensual: 110 galones al mes (agua perdida por fugas)',
        monthlyUsage110GalNoLeak: 'Consumo mensual: 110 galones al mes',
        fixPipeLeaks: 'Reparar fugas en las tuberías',
        fixPipeLeaksDescription:
      'Muchas casas pierden agua a través de tuberías con fugas. Contrata a un plomero para ayudar a encontrar fugas y repararlas.',
        cost200Savings110Gal: 'Coste: 200 $ Ahorro: 110 gal',
        outside: 'Afuera',
        goOutside: 'Ir afuera',
        garden: 'Jardín',
        monthlyUsage420Gal: 'Consumo mensual: 420 galones al mes',
        monthlyUsage420GalAvg:
      'Consumo mensual: 420 galones al mes (promedio: basado en 200 pies cuadrados)',
        replacePlants: 'Reemplaza con plantas nativas y que ahorran agua',
        replacePlantsDescription:
      'Reemplaza las flores y plantas que necesitan mucha agua con plantas nativas y resistentes a la sequía.',
        cost200Savings260Gal: 'Coste: 200 $ Ahorro: 260 gal',
        addMulch: 'Añadir mantillo',
        addMulchDescription: 'Añadir mantillo ayuda a retener el agua en el suelo.',
        cost50Savings60Gal: 'Coste: 50 $ Ahorro: 60 gal',
        cost250Savings270Gal: 'Coste: 250 $ Ahorro: 270 gal',
        wateringLawn: 'Riego del césped',
        monthlyUsage3000GalAvg: 'Consumo mensual: 3,000 galones al mes (promedio)',
        waterAtNight: 'Riega por la noche',
        waterAtNightDescription:
      'Si riegas por la noche, cuando hace fresco, el agua no se evaporará por el sol y no necesitarás usar tanta agua.',
        costNoneSavings750Gal: 'Coste: cero Ahorro: 750 gal',
        rainBarrel: 'Barril para lluvia',
        rainBarrelDescription:
      'Conecta un barril al bajante y ahorra el agua para tu césped.',
        cost50Savings55Gal: 'Coste: 50 $ Ahorro: 55 gal',
        cost50Savings805Gal: 'Coste: 50 $ Ahorro: 805 gal',
        totals: 'totales',
        summary: 'Resumen',
    },

    Tours: {
        title: 'Vistas de 360º',
        selectTile:
      'Selecciona una imagen para ver unas vistas panorámicas de 360º.',
        selectPoint:
      'Selecciona un punto y arrastra la imagen panorámica para girarla y mirar a tu alrededor.',
        start: 'Comenzar',
        southKaibabCanyon: '!!South Kaibab, The Grand Canyon',
        southKaibab: 'South Kaibab',
        yakiPoint: 'Yaki Point',
        toroweapOverlook: 'Mirador de Toroweap',
        southKaibabTrailhead: 'Inicio de la ruta South Kaibab',
    },
    SunriseSunsetCalculator: {
        title: 'Calculadora de amaneceres y atardeceres',
        jan: 'ene',
        feb: 'feb',
        mar: 'mar',
        apr: 'abril',
        may: 'may',
        jun: 'jun',
        jul: 'jul',
        aug: 'ago',
        sep: 'sep',
        oct: 'oct',
        nov: 'nov',
        dec: 'dic',
        january: 'enero',
        february: 'febrero',
        march: 'marzo',
        april: 'abril',
        june: 'junio',
        july: 'julio',
        august: 'agosto',
        september: 'septiembre',
        october: 'octubre',
        november: 'noviembre',
        december: 'diciembre',
        am: 'a. m.',
        pm: 'p. m.',
        hour: 'hora',
        hours: 'horas',
        minute: 'minuto',
        minutes: 'minutos',
        location: 'Para empezar, elige un lugar:',
        oops: 'Hubo un error. Asegúrate de escribir correctamente la <strong>ciudad</strong>, el <strong>estado o la provincia/región,</strong> o el <strong>código ZIP/postal.',
        pickDate: 'Ahora elige una fecha:',
        reset: 'Reiniciar',
        submit: 'Enviar',
        sunrise: 'Amanecer',
        lengthOfDay: 'Duración del día',
        sunset: 'Atardecer',
        welcome: '¡Descubre la calculadora de amaneceres y atardeceres de Twig!',
        start: 'Comenzar',
        ok: 'Aceptar',
    },
    Ecosystem: {
        title: 'Cambios en el ecosistema',
        exploreChanges:
      'Explora lo que puede ocurrir si se cambia una parte de la cadera alimentaria. Aumenta el número de organismos, disminuye su número o introduce un nuevo tipo de organismo. ¡Te sorprenderá descubrir cuánto puede alterar la cadena un pequeño cambio!',
        start: 'Comenzar',
        level1: 'Nivel 1',
        level2: 'Nivel 2',
        lakeTrout: 'Trucha lacustre',
        organism: 'Organismo',
        action: 'Acción',
        play: 'Iniciar simulación',
        reset: 'Reiniciar',
        whatsHappening: '¿Qué está ocurriendo?',
        year: 'Año',
        goingDown: 'disminuyen',
        algae: 'Algas',
        decreaseNumber: 'Disminuir la cantidad',
        keepSame: 'Mantener la cantidad',
        increaseNumber: 'Aumentar la cantidad',
        algaeDescription:
      'Las algas son plantas diminutas que viven en el agua. Obtienen su materia del agua y el aire, y su energía del sol.',
        insectLarvae: 'Larvas de insectos',
        insectLarvaeDescription:
      'Muchos insectos ponen sus huevos en el agua, y las crías de insectos, llamadas larvas, viven en el agua antes de transformarse en insectos adultos. Estas larvas obtienen su materia y energía al comer <b>algas</b>.',
        nativeTrout: 'Truchas nativas',
        nativeTroutDescription:
      'Las truchas nativas viven en el lago, los ríos y arroyos, y nadan río arriba cada año para reproducirse. Obtienen su materia y energía al comer <b>larvas de insectos</b>.',
        nonNativeTrout: 'Truchas no nativas',
        noLakeTrout: 'Ninguna trucha lacustre',
        addLakeTrout: 'Añadir truchas lacustres',
        addMoreLakeTrout: 'Añadir más truchas lacustres',
        nonNativeTroutDescription:
      'Estas truchas no nativas viven en el fondo del lago, por lo que no son comidas por los osos. Crecen mucho más que las truchas nativas. Comen tanto <b>larvas de insectos</b> como <b>truchas nativas</b>.',
        bear: 'Osos',
        bearDescription:
      'Estos osos pescan en los arroyos para alimentarse. Obtienen su materia y energía al comer <b>truchas nativas</b>.',
        goingUp: 'aumentan',
        noAction: 'No se puede cambiar',
        whatHappensChanges:
      '¿Qué ocurre cuando cambia el número de organismos en un ecosistema?',
        introAffect:
      '¿Cómo afecta a un ecosistema la introducción de un organismo no nativo?',
    },
    WaveBreakers: {
        title: 'Rompeolas',
        openOcean: 'Océano abierto',
        coast: 'Costa',
        makeChoices:
      'Elige tus opciones y observa con atención el movimiento del kayak.',
        makeChoicesStart:
      '"Elige tus opciones y pulsa Comenzar. Observa con atención el movimiento del kayak.',
        amplitude: 'Amplitud',
        small: 'Pequeña',
        medium: 'Media',
        large: 'Grande',
        wavelength: 'Longitud de onda',
        short: 'Corta',
        long: 'Larga',
        seafloor: 'Inclinación del lecho marino',
        gentle: 'Suave',
        moderate: 'Moderada',
        steep: 'Empinada',
        start: 'Comenzar',
        stop: 'Detener',
    },
    OurChangingWorld: {
        MediaGallery: 'Galería multimedia: nuestro mundo cambiante',
        DataInvestigation:
      'Los científicos recopilan y registran datos para investigar los cambios que ocurren en el mundo con el paso del tiempo. Elige una de las siguientes imágenes para ver lo que descubrieron hasta el momento.',
        SeaLevels: 'Cambios en el nivel del mar',
        SeaLevelsDetails:
      'Los datos de los satélites muestran que el nivel de los mares de todo el planeta ha ido cambiando. En este globo terráqueo se utilizan códigos de color para mostrar los cambios totales en varias áreas del océano entre 1992 y 2014.<br><br>Pulsa Reproducir o mueve el control deslizante para girar el globo. Usa la escala situada en la parte inferior para determinar qué áreas sufrieron pocos cambios y cuáles cambiaron mucho. La tierra se muestra en color gris oscuro.',
        Credits: 'Créditos',
        CreditsDetails:
      'Animación del Scientific Visualization Studio de la NASA/Goddard Space Flight Center <br>Datos sobre la Canica azul cortesía de Reto Stockli (NASA/GSFC)',
        Play: 'Reproducir',
        Help: 'Ayuda',
        title: 'Nuestro mundo cambiante',
        SeaSurfaceHeightChange:
      'Cambio de altura de la superficie del mar en 22 años',
        ArcticIceGraph:
      'Mínimo de hielo ártico anual entre 1979 y 2016 con gráfica superpuesta',
        SatelliteData:
      'Los datos de los satélites muestran que el nivel de los mares de todo el planeta ha ido cambiando. En este globo terráqueo se utilizan códigos de color para mostrar los cambios totales en varias áreas del océano entre 1992 y 2014.',
        RotateGlobe:
      'Pulsa Reproducir o mueve el control deslizante para girar el globo. Usa la escala situada en la parte inferior para determinar qué áreas sufrieron pocos cambios y cuáles cambiaron mucho. La tierra se muestra en color gris oscuro.',
        CarbonDioxideMeasurement:
      'Los científicos utilizan la medida <b>ppm</b> para medir la concentración de partes de dióxido de carbono en un millón de partes de aire. Estas medidas les ayudan a registrar los cambios que ocurren en los niveles de dióxido de carbono de la atmósfera con el paso del tiempo.',
        CO2Increase:
      'En esta visualización se muestra el aumento del dióxido de carbono en la atmósfera debido a la quema de combustibles fósiles (carbón, petróleo y gas natural) en los años 2011-2012.',
        CO2EmissionsChange:
      'Pulsa Reproducir o mueve el control deslizante para ver los cambios ocurridos con el paso del tiempo. Usa la escala de la parte inferior para observar en qué áreas aumentaron más las emisiones de dióxido de carbono.',
        TemperatureRecords:
      'Los científicos llevan desde 1880 registrando la temperatura de muchos lugares del mundo. Con estos datos, han determinado una temperatura media (o «normal»). En este mapa se muestra la temperatura en distintos lugares del mundo comparada con la media.',
        TemperatureChange:
      'Pulsa Reproducir o mueve el control deslizante para ver los cambios ocurridos con el paso del tiempo. Las temperaturas por debajo de la media se muestran con tonos entre azul claro y azul oscuro; las temperaturas más altas de la media se muestran con tonos entre amarillo y rojo.',
        ArcticIceTracking:
      'En el Polo Norte, la cantidad de hielo que cubre el océano Ártico es un indicador importante del clima mundial. Los científicos pueden hacer un seguimiento de la cantidad de hielo mediante los satélites. Cada año, miden la cantidad de hielo que cubre el océano Ártico durante el verano. Esta es la época con menos cantidad de hielo, lo que llaman el «mínimo». Esta visualización muestra la cantidad de hielo (en blanco) que había en el mínimo durante los años 1979-2016.',
        SeaIceChange:
      'Pulsa Reproducir o mueve el control deslizante para ver los cambios en el hielo marino con el paso del tiempo.',
        TempDifference: 'Diferencia de temperatura',
        Celsius: 'Celsius',
        PPM: 'ppm',
        ZeroCM: '0 (cm)',
        AnimationNASA: 'Animación del Scientific Visualization Studio de la NASA',
        SeaIce: 'Cambios en el hielo marino',
        CO2Emissions: 'Cambios en las emisiones de dióxido de carbono',
        AnimationNOAA:
      'Animación cortesía de Global Monitoring Division, Earth System Research Laboratory de NOAA',
        Jan2011: 'Ene 2011',
        Dec2012: 'Dic 2012',
        TempChange: 'Cambios en las temperaturas',
        AnimationNASAData:
      'Animación del Scientific Visualization Studio de la NASA/Goddard Space Flight Center <br>Datos proporcionados por Robert B. Schmunk (NASA/GSFC GISS)',
        Pause: 'Detener',
    },
    Seasons: {
        springFlowers: 'Flores de Primavera',
        growLikeFlower: '¿Puedes crecer como una flor?',
        nestEggs: 'Huevos en el Nido',
        whatHappensNext: '¿Qué está ocurriendo?',
        littleLambs: 'Pequeños Corderos',
        animalSounds: '¿Qué sonido hacen estos animales?',
        meltingTreat: 'Postre Derretido',
        whyIceCreamMelting: '¿Por qué se derrite el helado?',
        safeInSun: 'A Salvo en el Sol',
        protectSkinSun: '¿Cómo podemos proteger nuestra piel del sol?',
        whatToWear: 'Qué Ropa Usar',
        wearWhenWarm: '¿Qué te pones cuando hace calor?',
        prepareForWinter: 'Prepárate para el Invierno',
        squirrelDoing: '¿Qué está haciendo esta ardilla?',
        scareSeason: 'Temporada de Susto',
        celebrateHalloween: '¿Qué haces para celebrar Halloween?',
        fallingLeaves: 'Hojas Caídas',
        pretendFallingLeaf: '¿Puedes hacer como si fueras una hoja que cae?',
        gettingChilly: 'Se Está Poniendo Frío',
        waterWhenCold: '¿Qué le pasa al agua cuando hace mucho frío?',
        wrapUp: '¡Abrígate!',
        wearWhenCold: '¿Qué te pones cuando hace mucho frío?',
        upClose: 'De Cerca',
        snowflakeUpClose: '¿Cómo se ve un copo de nieve de cerca?',
        whereLeavesGo: '¿Dónde se fueron las hojas?',
        leavesGrowBack: '¿Cuándo volverán a crecer estas hojas?',
        title: 'Estaciones',
        chooseSeason: 'Elige una Estación',
        spring: 'Primavera',
        summer: 'Verano',
        fall: 'Otoño',
        winter: 'Invierno',
    },
    BodySystems: {
        title: 'Sistemas del cuerpo',
        help: 'Ayuda',
        choose: '1. Elige una planta.',
        drag: '2. Arrastra y coloca las partes de la planta para crear tu modelo. Cuando termines el modelo, usa las palabras para etiquetar cada parte.',
        selectDownload: '3. Selecciona «descargar» para guardar tu modelo.',
        selectBack:
      '4. Selecciona «atrás» para volver al menú principal. Si tienes tiempo, elige y crea otra planta.',
        buildHuman: 'Construir un humano',
        start: 'Comenzar',
        chooseSystem: 'elige una planta',
        download: 'descargar',
        skull: 'cráneo',
        armBones: 'huesos del brazo',
        ribCage: 'caja torácica',
        legBones: 'huesos de la pierna',
        lung: 'pulmón',
        windpipe: 'tráquea',
        mouth: 'boca',
        nose: 'nariz',
        intestines: 'intestino',
        stomach: 'estómago',
        heart: 'corazón',
        bloodVessels: 'vasos sanguíneos',
        brain: 'cerebro',
        nerves: 'nervios',
        circulatorySystem: 'Sistema Circulatorio',
        skeletonSystem: 'Sistema Esquelético',
        breathingSystem: 'Sistema Respiratorio',
        digestiveSystem: 'Sistema Digestivo',
        nerveSystem: 'Sistema Nervioso',
        fullBodySystem: 'Sistema Completo',
        system: 'sistema',
    },
    ClimateExplorer: {
        title: 'Explorador del clima',
        Countries: 'Países',
        LosAngeles: 'Los Ángeles, California, EE. UU.',
        Seattle: 'Seattle, Washington, EE. UU.',
        Washington: 'Washington, Distrito de Columbia, EE. UU.',
        Pierre: 'Pierre, Dakota del Sur, EE. UU.',
        StLouis: 'St. Louis, Misuri, EE. UU.',
        Lahaina: 'Lahaina, Hawái, EE. UU.',
        Nome: 'Nome, Alaska, EE. UU.',
        Cincinnati: 'Cincinnati, Ohio, EE. UU.',
        Miami: 'Miami, Florida, EE. UU.',
        Sacramento: 'Sacramento, California, EE. UU.',
        Dublin: 'Dublín, Irlanda',
        Lisbon: 'Lisboa, Portugal',
        Berlin: 'Berlín, Alemania',
        Manchester: 'Mánchester, Reino Unido',
        Warsaw: 'Varsovia, Polonia',
        Tromsø: 'Tromsø, Noruega',
        Cairo: 'El Cairo, Egipto',
        Lagos: 'Lagos, Nigeria',
        CapeTown: 'Ciudad del Cabo, Sudáfrica',
        Kampala: 'Kampala, Uganda',
        Jerusalem: 'Jerusalén, Oriente Próximo',
        Istanbul: 'Estambul, Turquía',
        Kiev: 'Kiev, Ucrania',
        Moscow: 'Moscú, Rusia',
        Yakutsk: 'Yakutsk, Rusia',
        Beijing: 'Pekín, China',
        Bangkok: 'Bangkok, Tailandia',
        NewDelhi: 'Nueva Delhi, la India',
        Singapore: 'Singapur',
        AliceSprings: 'Alice Springs, Australia',
        Adelaide: 'Adelaida, Australia',
        Sydney: 'Sídney, Australia',
        Winnipeg: 'Winnipeg, Manitoba, Canadá',
        SantaCruz: 'Santa Cruz de la Sierra, Bolivia',
        Rio: 'Río de Janeiro, Brasil',
        Córdoba: 'Córdoba, Argentina',
        Manaus: 'Manaos, Brasil',
        PuertoMaldonado: 'Puerto Maldonado, Perú',
        RioGallegos: 'Río Gallegos, Argentina',
        McMurdo: 'Base McMurdo, Antártida',
        Tokyo: 'Tokio, Japón',
        Akureyri: 'Akureyri, Islandia',
        Kinshasa: 'Kinshasa, RD Congo',
        Astana: 'Astaná, Kazajistán',
        PuertoVallarta: 'Puerto Vallarta, México',
        Marrakesh: 'Marrakech, Marruecos',
        SantaFe: 'Santa Fe, Nuevo México, EE. UU.',
        Kufra: 'Kufra, Libia',
        Baghdad: 'Bagdad, Iraq',
        Arica: 'Arica, Chile',
        Latitude: 'Latitud',
        AverageTemperature: 'Temperatura media',
        AverageHigh: 'Máxima media anual',
        AverageLow: 'Mínima media anual',
        AnnualPrecipitation: 'Precipitación anual',
        TemperatureRange: 'Amplitud térmica',
        Precipitation: 'Precipitación',
    },
    HabitatExplorer: {
        title: 'Explorador de hábitats',
        subtitle: 'Elige un hábitat',
        great: '¡Estupendo!',
        ok: 'De acuerdo',
        foundItemName:
      'You found the item name! Add this <b></b> to the table in your Twig Book.',
        foundName:
      '¡Encontraste <b>*CLICKEDITEM*</b>! Añade <b>*TYPE*</b> a la tabla de tu Cuaderno Twig.',
        sorry: '¡Qué lástima!',
        incorrect: 'No es correcto.',
        keepSearching: '¡Sigue buscando!',
        left: 'izquierda',
        right: 'derecha',
        foundNonLivingThing:
      'Añade esta cosa inanimada a la tabla de tu Cuaderno Twig.',
        whatAmI: '¿Qué soy?',
        searchFieldGuide: 'Busca en la guía de campo y haz clic en mí.',
        fieldGuide: 'Guía de campo:',
        plant: 'esta planta',
        animal: 'este animal',
        nonLivingThing: 'cosa inanimada',
        desert: 'El desierto',
        saguaro: 'el saguaro',
        saguaroDescription:
      'Los saguaro son cactus grandes que parecen árboles. Están cubiertos de espinas afiladas. Pueden almacenar el agua de la lluvia en su interior para sobrevivir durante largos períodos sin lluvia.',
        pricklyPear: 'el nopal',
        pricklyPearDescription:
      'El nopal se conoce también como «higuera de pala». Tiene las hojas ovaladas y planas, con forma de palas. Es nativo del continente americano.',
        brittlebush: 'el incienso',
        brittlebushDescription:
      'El incienso o rama blanca es un arbusto redondeado de tamaño mediano. Los tallos del incienso tienen un líquido que los indígenas americanos usaban como pegamento y chicle.',
        redTailedHawk: 'el halcón cola roja',
        redTailedHawkDescription:
      'El halcón cola roja es común en el desierto durante todo el año. Los halcones tienen muy buena vista. Cazan roedores, como los ratones, y otras presas.',
        vulture: 'el buitre',
        vultureDescription:
      'El buitre o zopilote come animales muertos. Puede pasar varios días sin comer, gastando poca energía mientras planea durante horas.',
        rattlesnake: 'la serpiente de cascabel',
        rattlesnakeDescription:
      '"La mordedura de la serpiente de cascabel es venenosa. Esta serpiente se reconoce por su cola en forma de cascabel. Esta hace un ruido fuerte que avisa a los depredadores de que se mantengan alejados.',
        harvesterAnt: 'la hormiga cosechadora',
        harvesterAntDescription:
      'Las hormigas cosechadoras viven en grupos llamados colonias. Almacenan la comida en zonas especiales dentro de estos montículos. Una hormiga puede levantar un peso muy superior al de su cuerpo.',
        desertTortoise: 'la tortuga del desierto',
        desertTortoiseDescription:
      'La selva tropical es muy cálida porque recibe mucho sol directo. El sol junto con la lluvia lo convierten en un lugar muy húmedo para vivir.',
        scorpion: 'el escorpión',
        scorpionDescription:
      'El escorpión o alacrán tiene pinzas y una cola larga con un aguijón. Su picadura es venenosa. Usa el aguijón para cazar a sus presas, normalmente insectos, y para defenderse.',
        jackrabbit: 'la liebre del desierto',
        jackrabbitDescription:
      'En el desierto viven al menos dos tipos de liebres, como la liebre de cola negra y la liebre antílope. Estas liebres viven en espacios abiertos y son muy rápidas. Necesitan su gran velocidad y su habilidad de saltar para escapar de sus depredadores.',
        grayFox: 'el zorro gris',
        grayFoxDescription:
      'El zorro gris caza por la noche. Come animales de pequeño tamaño e incluso algunas plantas. Es capaz de trepar a los árboles y a veces duerme en ellos para estar a salvo de los depredadores.',
        sand: 'la arena',
        sandDescription:
      'En el desierto hay tierra y arena de varios colores. En algunos sitios es gris, en otros roja o rosa. También hay arena y tierra de texturas distintas.',
        rocks: 'las rocas',
        rocksDescription:
      'En el desierto de Sonora, las rocas salieron a la superficie cuando el terreno se resquebrajó en el pasado. Muchos animales usan estos afloramientos de roca como casa.',
        notWater: 'poca agua',
        notWaterDescription:
      'El desierto de Sonora solo recibe entre 8 y 40 centímetros de lluvia al año. El aire húmedo que viene del océano está casi seco cuando llega al desierto.',
        hotDay: 'calor durante el día',
        hotDayDescription:
      'En algunas zonas del desierto, la temperatura puede alcanzar los 130 °F (55 °C) a la sombra durante el día. ¡Pero por la noche hace frío y puede llegar a helar!',
        rainForest: 'La selva tropical',
        rubberTree: 'el árbol del caucho',
        rubberTreeDescription:
      'El árbol del caucho produce una savia lechosa que se puede recolectar de la planta cuando cumple unos seis años. Esta savia es la que se usa para crear el hule.',
        palmTree: 'la palma',
        palmTreeDescription:
      'Las palmas son los árboles más comunes en la selva tropical. Sus frutos se sirven a menudo con helado o chocolate. ¡Qué sabrosos!',
        kapok: 'la ceiba',
        kapokDescription:
      'La ceiba puede alcanzar los 70 metros de altura y unos 3 metros de diámetro. Estos árboles tienen flores aromáticas que se abren por la noche y atraen a los murciélagos.',
        liana: 'la liana',
        lianaDescription:
      'Una liana es un tallo de enredadera largo y leñoso que usa los árboles para trepar hasta el dosel y alcanzar la luz del sol. Los animales usan estas enredaderas como «puentes» para cruzar de árbol en árbol.',
        orchid: 'la orquídea',
        orchidDescription:
      'La mayoría de las orquídeas dependen de una sola especie de ave o abeja para su polinización. Si se mueren todos los animales de esa especie, ¡es un gran problema para las orquídeas!',
        bromeliad: 'la bromelia',
        bromeliadDescription:
      'Las bromelias son plantas con flores muy frecuentes en las selvas tropicales de América Central y del Sur. Muchas de ellas almacenan agua en estructuras que crean con sus densas hojas superpuestas.',
        fern: 'el helecho',
        fernDescription:
      'Los helechos son una de las especies de plantas más antiguas que hay todavía en la Tierra. Sus hojas se llaman frondas y tienen una raíz que absorbe fácilmente el agua y todos los nutrientes que necesitan.',
        waterLily: 'el nenúfar',
        waterLilyDescription:
      'Los nenúfares flotan en la superficie del agua mientras que sus raíces se hunden en el fondo del lago o la poza. En la selva tropical, las flores permanecen abiertas día y noche hasta que se marchitan.',
        jaguar: 'el jaguar',
        jaguarDescription:
      'El jaguar es el tercer felino más grande del mundo y el mayor del continente americano. Suele cazar solo. Sus manchas parecen rosas y se llaman rosetas.',
        spiderMonkey: 'el mono araña',
        spiderMonkeyDescription:
      'Los monos araña se cuelgan a menudo de los árboles con las cuatro patas (¡y la cola!). Eso hace que parezcan arañas.',
        glasswingButterfly: 'la mariposa de cristal',
        glasswingButterflyDescription:
      'La mariposa de cristal tiene las alas transparentes; de ahí su nombre. ¡Pero no te la comas! La mariposa come frutos tóxicos cuando es una oruga y no es buena como botana.',
        leafCutterAnd: 'la hormiga cortadora de hojas',
        leafCutterAntDescription:
      'Las hormigas cortadoras de hojas se llaman así por sus mandíbulas fuertes, que pueden cortar trozos de hojas con facilidad. También tienen varias espinas en la piel para protegerse.',
        toucan: 'el tucán',
        toucanDescription:
      'Los tucanes de la selva tropical tienen picos de colores vivos y manchas coloridas en las plumas. ¡El pico puede llegar a ser tan largo como la mitad que su cuerpo!',
        treeFrog: 'la rana arbórea',
        treeFrogDescription:
      'Hay más de 1,000 tipos de ranas diferentes en la selva tropical. La mayoría de ellas viven en los árboles. Ponen los huevos en las plantas o incluso en la tierra, en vez de en el agua.',
        piranha: 'la piraña',
        piranhaDescription:
      'Hay muchas historias de terror acerca de las pirañas. Sin embargo, no suelen comer seres humanos. Se alimentan de plantas y animales, pero solo comen animales grandes si ya están muertos.',
        macaw: 'la guacamaya',
        macawDescription:
      'Las guacamayas son aves inteligentes con plumas de colores vivos. Las plumas de la cara de cada ave siguen un patrón distinto, algo así como las huellas dactilares de los seres humanos.',
        treeSnake: 'la serpiente arborícola',
        treeSnakeDescription:
      'Las serpientes arborícolas son unas artistas del disfraz: se confunden con el follaje de los árboles. Tienen mucha fuerza, lo que les permite colgarse de las ramas para atrapar a sus presas.',
        anteater: 'el oso hormiguero',
        anteaterDescription:
      'Los osos hormigueros tienen la nariz larga y la lengua todavía más larga, ¡pero no tienen dientes! Usan sus garras para cavar en los nidos de termitas y hormigas, y atrapan a los insectos con la lengua.',
        sloth: 'el perezoso',
        slothDescription:
      'Hay una razón por la que se usa la palabra «perezoso» para describir a alguien que flojea. Estos animales se mueven con una lentitud extrema y pueden dormir hasta 18 horas seguidas.',
        riverDolphin: 'el delfín de río',
        riverDolphinDescription:
      'Los delfines de río son distintos a otros delfines que viven en el océano. Muchos son de color rosado y prefieren estar solos casi todo el año en vez de juntarse en una vaina o grupo.',
        river: 'el río',
        riverDescription:
      'El río es una característica importante de muchas selvas tropicales. En él viven muchos animales, como el delfín de río y la piraña. Es una fuente enorme de agua dulce para el planeta.',
        soil: 'la tierra',
        soilDescription:
      'El suelo de la selva tropical es bueno para la vida que crece en él de forma natural, pero no es bueno para la agricultura. Son muy pocos los cultivos plantados por los seres humanos que crecen bien aquí.',
        rain: 'mucha lluvia',
        rainDescription:
      '¡La selva tropical recibe más de 3 metros de lluvia al año!',
        warm: 'calidez',
        warmDescription:
      'La selva tropical es muy cálida porque recibe mucho sol directo. El sol junto con la lluvia lo convierten en un lugar muy húmedo para vivir.',
        farm: 'La granja',
        potato: 'la papa',
        potatoDescription:
      'Las papas crecen en la raíz de la planta y a mucha gente le gusta comerlas. Casi todos las consideran una verdura, pero tienen tanto almidón que se parecen más al arroz, la pasta o el pan.',
        grass: 'el pasto',
        grassDescription:
      'Hay más de 10,000 tipos de pasto. A diferencia de casi todas las plantas, los pastos crecen por la base en vez de por la punta. Eso les permite seguir creciendo aunque las corten o se las coman.',
        cottontail: 'el conejo de cola blanca',
        cottontailDescription:
      'Los dientes del conejo nunca dejan de crecer y tiene que rechinarlos continuamente cuando mastica. También salta muy bien: algunos pueden saltar hasta casi un metro de altura.',
        hawk: 'la aguililla real',
        hawkDescription:
      'Las aguilillas son aves oportunistas; es decir, que comen lo que esté disponible en su hábitat. Su dieta incluye insectos, aves, ratones, conejos, ranas y serpientes.',
        cow: 'la vaca',
        cowDescription:
      'Las vacas producen el 90 % de la leche que bebemos las personas. Las vacas dan leche durante una media de 3 o 4 años desde que tienen un ternero.',
        bee: 'la abeja',
        beeDescription:
      'Las abejas son muy sociales: en una sola colmena pueden vivir hasta 50,000 abejas. ¡Pero ten cuidado! Las abejas tienen aguijones y los usan cuando se sienten amenazadas.',
        human: 'el ser humano',
        humanDescription:
      'Los seres humanos somos un tipo de animal. Podemos cambiar e influir en la Tierra de muchas maneras. Por ejemplo, hay personas que crear granjas y las cuidan para obtener comida.',
        soilFarmDescription:
      'La tierra de las granjas suele ser rica en nutrientes. Eso permite cultivar, por ejemplo, papas o trigo. Los granjeros labran la tierra y plantan semillas cada primavera para que crezcan las plantas.',
        water: 'el agua',
        waterDescription:
      'Los granjeros necesitan agua para cultivar. Algunos granjeros usan sistemas de riego por aspersión. También traen agua para sus animales en cubetas y bebederos.',
    },
};

export default languageEs;
